import { IMetaSeo } from '@zmedia/bm-soccer-ui/interface';

export const SEO_DEFAULT: IMetaSeo = {
    type: 'website',
    title:
        'BScore - Football Live Scores',
    ogTitle:
        'BScore - Football Live Scores',
    description:
        'Báo Mới - Trang tin tự động cập nhật các tin tức Việt Nam và thế giới từ các báo và trang tin điện tử hàng đầu',
    keywords:
        'báo mới, baomoi, bao moi, tin tức, tin tuc, tổng hợp tin tức, cập nhật, báo điện tử, mới, nóng, nhanh, hot, Việt Nam, thế giới, biển đông, hà nội, tp hcm, sài gòn, xã hội, văn hóa, kinh tế, khoa học, công nghệ, thể thao, bóng đá, giải trí, pháp luật, giáo dục, sức khỏe, ô tô, xe máy, nhà đất.',
    robots: 'noarchive',
    googlebot: 'noarchive',
    url: '/',
    ogUrl: '/',
    imageUrl: 'https://baomoi-static.bmcdn.me/web/styles/img/facebook-thumb.png',
    imageWidth: '560',
    imageHeight: '292',
};

export const JSON_LD_DEFAULT: any = {
    name: 'BScore - Football Live Scores',
    alternateName:
        'Báo Mới - Trang tin tự động cập nhật các tin tức Việt Nam và thế giới từ các  báo và  trang tin điện tử hàng đầu',
    url: 'https://baomoi.com',
    '@context': 'http://schema.org',
    '@type': 'WebSite',
};
